(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3188],{

/***/ 63188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3215);
/* harmony import */ var _styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71911);
/* harmony import */ var _data_home__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44330);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88494);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3557);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55642);
/* harmony import */ var _product_card_product_card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91740);












swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
]);
var New_Arrivals = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref[0], setData = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        newArrival();
    }, []);
    var newArrival = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _api_http_client__WEBPACK_IMPORTED_MODULE_8__/* ["default"].get */ .Z.get(_api_endpoints__WEBPACK_IMPORTED_MODULE_7__/* ["default"].home.newArrival */ .Z.home.newArrival());
                    case 3:
                        data = _ctx.sent.data;
                        setData(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function newArrival() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!data.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
            className: (_styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11___default().new_arrivals),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "w-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11___default().new_arrivalsheader),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                    children: _data_home__WEBPACK_IMPORTED_MODULE_4__/* .homeLinks.newArival.title */ .n.newArival.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("fw-embed-feed", {
                            channel: "senco",
                            playlist: "5aKDPg",
                            mode: "row",
                            open_in: "default",
                            max_videos: "0",
                            placement: "middle",
                            player_placement: "bottom-right",
                            branding: "false"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11___default().new_arrivals_main),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "container-fluid",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                        className: "swiper-navigation-black swiper-custom-arrows",
                                        navigation: true,
                                        spaceBetween: 20,
                                        slidesPerView: 1,
                                        loop: true,
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 2
                                            },
                                            768: {
                                                slidesPerView: 3
                                            },
                                            1024: {
                                                slidesPerView: 4
                                            },
                                            1200: {
                                                slidesPerView: 4
                                            }
                                        },
                                        children: data.slice(0, 20).map(function(product) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_product_card_product_card__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    product: product
                                                })
                                            }, product.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        href: "/new-arrivals",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (_styles_new_arrivals_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn_get_started),
                                            children: [
                                                "SEE ALL Products ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                                    className: "bi bi-arrow-right"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (New_Arrivals);


/***/ }),

/***/ 3215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"new_arrivals":"new_arrivals_new_arrivals___zggE","new_arrivalsheader":"new_arrivals_new_arrivalsheader__0iX1W","new_arrivals_main":"new_arrivals_new_arrivals_main__CEtqe","new_arrivals_card":"new_arrivals_new_arrivals_card__PGtvT","new_arrivals_wishlist":"new_arrivals_new_arrivals_wishlist__F4y8q","add_to_card":"new_arrivals_add_to_card__GwKn4","btn_get_started":"new_arrivals_btn_get_started__B0Ggo","d_block_hover":"new_arrivals_d_block_hover__q1CSX","best_ss_p":"new_arrivals_best_ss_p__Z40NV","text_p":"new_arrivals_text_p__S64MS","card_new":"new_arrivals_card_new__IZWFq"};

/***/ })

}]);